// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 9 hooks for backend/compliance.

import { useBackend } from '../useBackend'

/** POST /api/compliance/changeContractSetting */
export function useChangeContractSetting<T = any>() {
  return useBackend<T>('compliance/changeContractSetting')
}

/** POST /api/compliance/confirmRecordWitness */
export function useConfirmRecordWitness<T = any>() {
  return useBackend<T>('compliance/confirmRecordWitness')
}

/** POST /api/compliance/getContractCompliance */
export function useGetContractCompliance<T = any>() {
  return useBackend<T>('compliance/getContractCompliance')
}

/** POST /api/compliance/getDriverRecords */
export function useGetDriverRecords<T = any>() {
  return useBackend<T>('compliance/getDriverRecords')
}

/** POST /api/compliance/openRecordFile */
export function useOpenRecordFile<T = any>() {
  return useBackend<T>('compliance/openRecordFile')
}

/** POST /api/compliance/recordPaperRecord */
export function useRecordPaperRecord<T = any>() {
  return useBackend<T>('compliance/recordPaperRecord')
}

/** POST /api/compliance/recordRecordRefusal */
export function useRecordRecordRefusal<T = any>() {
  return useBackend<T>('compliance/recordRecordRefusal')
}

/** POST /api/compliance/signRecordUpload */
export function useSignRecordUpload<T = any>() {
  return useBackend<T>('compliance/signRecordUpload')
}

/** POST /api/compliance/voidEmployeeRecord */
export function useVoidEmployeeRecord<T = any>() {
  return useBackend<T>('compliance/voidEmployeeRecord')
}
